/* ------------------------------------------------------------------
   MarketingLayout.js — parent layout for the Marketing section.
   Sub-navigation lives in the dashboard sidebar (collapsible "Marketing"
   group), so this is a thin wrapper that just renders the active sub-page.
   Keeps room for Email Marketing / SMS Marketing pages later.
------------------------------------------------------------------ */
import React from 'react';
import { Outlet } from 'react-router-dom';

export default function MarketingLayout() {
  return <Outlet />;
}
